import {useSelector} from 'react-redux';

import {TariffBooleanLimit} from 'entities/tariff';

import {userSelector} from './authSlice';
import {hasTariffFlag} from '../lib/tariffLimit';

export const useTariffFlag = (flag: TariffBooleanLimit): boolean => {
    const user = useSelector(userSelector);

    return hasTariffFlag(user, flag);
};

export default useTariffFlag;
